export const OFFICE_SUITE_MS_OFFICE = "msoffice";
export const OFFICE_SUITE_LIBRE_OFFICE = "libreoffice";

export type OfficeSuite =
  | typeof OFFICE_SUITE_MS_OFFICE
  | typeof OFFICE_SUITE_LIBRE_OFFICE;

function getMimeTypeForSpreadSheet(officeSuite?: OfficeSuite): string {
  return officeSuite === OFFICE_SUITE_MS_OFFICE ?
      "application/vnd.ms-excel"
    : "application/vnd.oasis.opendocument.spreadsheet";
}

function getMimeTypeForTextDoc(officeSuite?: OfficeSuite): string {
  return officeSuite === OFFICE_SUITE_MS_OFFICE ? "application/msword" : (
      "application/vnd.oasis.opendocument.text"
    );
}

export function getMimeType(
  officeSuite: OfficeSuite | undefined,
  extension: string,
): string {
  if (extension === "excel") {
    return getMimeTypeForSpreadSheet(officeSuite);
  }
  if (extension === "word") {
    return getMimeTypeForTextDoc(officeSuite);
  }

  switch (extension) {
    case "xls":
      return "application/vnd.ms-excel";
    case "ods":
      return "application/vnd.oasis.opendocument.spreadsheet";
    case "doc":
      return "application/msword";
    case "odt":
      return "application/vnd.oasis.opendocument.text";
    default:
      return "application/pdf";
  }
}
